<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- ============ LEFT: HERO + FORM ============ -->
      <div class="col-12 col-lg-8">

        <!-- Hero banner -->
        <div class="card bg-gradient-primary overflow-hidden mb-4">
          <div class="card-body position-relative py-4">
            <span class="hero-glow"></span>
            <div class="row align-items-center position-relative">
              <div class="col-auto">
                <div class="icon icon-shape icon-lg bg-white shadow text-center border-radius-lg">
                  <i class="ni ni-mobile-button text-dark opacity-10" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col">
                <h5 class="text-white mb-0">Update Aplikasi Mobile</h5>
                <p class="text-white text-sm opacity-8 mb-0">
                  Atur versi terbaru &amp; upload APK di sini. Aplikasi otomatis menawarkan update ke semua karyawan saat dibuka.
                </p>
              </div>
            </div>

            <div class="row mt-4 position-relative">
              <div class="col-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">Versi Aktif</span>
                  <span class="hero-stat-value">{{ data.version_name || '-' }}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">Version Code</span>
                  <span class="hero-stat-value">{{ data.version_code ?? '-' }}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">File APK</span>
                  <span class="hero-stat-value">
                    <i class="fa" :class="data.apk_filename ? 'fa-check-circle text-success' : 'fa-times-circle text-white opacity-6'" aria-hidden="true"></i>
                    {{ data.apk_filename ? 'Tersedia' : 'Belum ada' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form card -->
        <div class="card">
          <div class="card-body">

            <!-- Section: version info -->
            <div class="d-flex align-items-center mb-3">
              <div class="icon icon-shape icon-sm bg-gradient-primary shadow text-center border-radius-md me-2">
                <i class="ni ni-badge text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <h6 class="mb-0 text-sm">Informasi Versi</h6>
            </div>

            <label class="form-control-label">Nama Versi <span class="text-danger">*</span></label>
            <input type="text" class="form-control" placeholder="contoh: 1.1.0" v-model="data.version_name" required>
            <p class="text-xs text-secondary mt-1 mb-0">Sesuai <code>version</code> di <code>pubspec.yaml</code> (bagian sebelum tanda +), ditampilkan ke karyawan.</p>

            <div class="row mt-3">
              <div class="col-md-6">
                <label class="form-control-label">Version Code <span class="text-danger">*</span></label>
                <input type="number" class="form-control" v-model.number="data.version_code" required>
                <p class="text-xs text-secondary mt-1 mb-0">Sesuai <code>pubspec.yaml</code> (bagian sesudah tanda +). Harus naik setiap rilis.</p>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Min Version Code <span class="text-danger">*</span></label>
                <input type="number" class="form-control" v-model.number="data.min_version_code" required>
                <p class="text-xs text-secondary mt-1 mb-0">Di bawah ini, update wajib dan tidak bisa ditutup.</p>
              </div>
            </div>

            <hr class="horizontal dark my-4">

            <!-- Section: release notes -->
            <div class="d-flex align-items-center mb-3">
              <div class="icon icon-shape icon-sm bg-gradient-info shadow text-center border-radius-md me-2">
                <i class="ni ni-single-copy-04 text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <h6 class="mb-0 text-sm">Catatan Rilis</h6>
            </div>
            <textarea class="form-control" rows="3" placeholder="Apa yang baru di versi ini..." v-model="data.release_notes"></textarea>
            <p class="text-xs text-secondary mt-1 mb-0">Opsional &mdash; tampil di dialog update karyawan.</p>

            <hr class="horizontal dark my-4">

            <!-- Section: apk upload -->
            <div class="d-flex align-items-center mb-3">
              <div class="icon icon-shape icon-sm bg-gradient-success shadow text-center border-radius-md me-2">
                <i class="ni ni-cloud-upload-96 text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <h6 class="mb-0 text-sm">File APK</h6>
            </div>

            <label class="dropzone" :class="{ 'dropzone-filled': apkFile }">
              <input type="file" accept=".apk" class="d-none" @change="fileChange">
              <i class="fa fa-cloud-upload-alt dropzone-icon" aria-hidden="true"></i>
              <span class="dropzone-text" v-if="!apkFile">Klik untuk pilih file <strong>.apk</strong></span>
              <span class="dropzone-text" v-else><strong>{{ apkFile.name }}</strong> &middot; {{ formatSize(apkFile.size) }}</span>
            </label>

            <div class="current-apk mt-3" v-if="data.apk_filename">
              <i class="fa fa-file-archive text-success" aria-hidden="true"></i>
              <span class="text-xs text-secondary">
                APK tersimpan saat ini &mdash;
                <a :href="apiUrl + 'mobile/version/apk'" target="_blank">download</a>
                <span v-if="data.updated_at"> &middot; diperbarui {{ moment(data.updated_at).locale('id').format('D MMMM YYYY, HH:mm') }}<span v-if="data.updated_by"> oleh {{ data.updated_by }}</span></span>
              </span>
            </div>
            <p class="text-xs text-secondary mt-2 mb-0" v-else>
              Belum ada APK yang diupload. Kosongkan field ini jika hanya ingin mengubah catatan/versi tanpa mengganti file.
            </p>

            <div class="text-end mt-4">
              <argon-button variant="gradient" color="success" size="sm" @click="save()">
                <i class="fa fa-save fa-sm" aria-hidden="true"></i> Simpan
              </argon-button>
            </div>
          </div>
        </div>
      </div>

      <!-- ============ RIGHT: LIVE PREVIEW ============ -->
      <div class="col-12 col-lg-4">
        <div class="position-sticky" style="top: 20px;">
          <p class="text-xxs text-uppercase text-secondary font-weight-bolder ms-1 mb-2">Pratinjau di HP Karyawan</p>
          <div class="phone-frame">
            <div class="phone-notch"></div>
            <div class="phone-dialog">
              <h6 class="mb-2">{{ previewForced ? 'Update wajib dilakukan' : 'Update tersedia' }}</h6>
              <p class="text-sm mb-2">
                Versi <strong>{{ data.version_name || '-' }}</strong> sudah tersedia (kamu memakai versi sebelumnya).
              </p>
              <p class="text-xs mb-2" style="color: #DC2626;" v-if="previewForced">
                Versi ini sudah tidak didukung, silakan update untuk melanjutkan.
              </p>
              <template v-if="data.release_notes">
                <p class="text-xs font-weight-bolder mb-1 mt-3">Apa yang baru</p>
                <p class="text-xs text-secondary mb-0">{{ data.release_notes }}</p>
              </template>
              <div class="phone-dialog-actions">
                <span class="phone-btn-text" v-if="!previewForced">Nanti</span>
                <span class="phone-btn-filled">Update</span>
              </div>
            </div>
          </div>
          <p class="text-xs text-secondary text-center mt-2 mb-0">
            Ilustrasi dialog yang muncul di HP karyawan yang versinya lebih lama.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import appVersion from '@/services/appVersion.service';
import akun from '@/services/akun.service';
import config from '@/configs/config';
import moment from 'moment';

export default {
  name: "app-version",
  components: {
    ArgonButton,
  },
  data() {
    return {
      data: {
        version_name: '',
        version_code: 1,
        min_version_code: 1,
        release_notes: '',
        apk_filename: null,
      },
      apkFile: null,
      apiUrl: config.apiUrl,
    };
  },
  computed: {
    // A release whose min_version_code has caught up to its own version_code
    // means update is forced for everyone still on an older build -- same
    // "forced" check the mobile app itself does (current < min_version_code).
    previewForced() {
      return this.data.min_version_code != null && this.data.version_code != null && this.data.min_version_code >= this.data.version_code;
    },
  },
  mounted() {
    this.get();
    this.getRole();
  },
  methods: {
    moment,
    formatSize(bytes) {
      if (!bytes) return '0 KB';
      const mb = bytes / (1024 * 1024);
      return mb >= 1 ? mb.toFixed(1) + ' MB' : Math.round(bytes / 1024) + ' KB';
    },
    get() {
      let context = this;
      Api(context, appVersion.show()).onSuccess(function(response) {
        if (response.data.data) {
          context.data = response.data.data;
        }
      }).onError(function() {
        context.notify('Gagal memuat data versi aplikasi', 'error')
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    fileChange(e) {
      this.apkFile = e.target.files[0] || null;
    },
    save() {
      let context  = this;
      let formData = new FormData();

      if (!context.data.version_name || !context.data.version_code || context.data.min_version_code === '' || context.data.min_version_code === null) {
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      formData.append('version_name', context.data.version_name);
      formData.append('version_code', context.data.version_code);
      formData.append('min_version_code', context.data.min_version_code);
      formData.append('release_notes', context.data.release_notes || '');
      if (context.apkFile instanceof File) {
        formData.append('apk', context.apkFile);
      }

      Api(context, appVersion.update(formData)).onSuccess(function(response) {
        context.data = response.data.data;
        context.apkFile = null;
        context.notify('Data Berhasil di Simpan', 'success')
      }).onError(function() {
        context.notify('Data Gagal di Simpan', 'error')
      })
      .call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
.hero-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%);
  pointer-events: none;
}
.hero-stat {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255,0.08);
  border-radius: 0.75rem;
  padding: 10px 12px;
}
.hero-stat-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.7);
}
.hero-stat-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
}

.icon-sm {
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
}

.dropzone {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 2px dashed #CBD5E1;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  margin: 0;
}
.dropzone:hover {
  border-color: #17c1e8;
  background-color: #f8fdff;
}
.dropzone-filled {
  border-style: solid;
  border-color: #2dce89;
  background-color: #f6fffb;
}
.dropzone-icon {
  font-size: 1.5rem;
  color: #8392AB;
}
.dropzone-filled .dropzone-icon {
  color: #2dce89;
}
.dropzone-text {
  font-size: 0.8rem;
  color: #67748e;
}

.current-apk {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f0fdf6;
  border-radius: 0.5rem;
  padding: 8px 12px;
}

.phone-frame {
  background: #1A1D29;
  border-radius: 1.75rem;
  padding: 14px 10px 24px;
  box-shadow: 0 20px 40px -12px rgba(0,0,0,0.35);
}
.phone-notch {
  width: 50px;
  height: 6px;
  background: #3a3d4a;
  border-radius: 999px;
  margin: 0 auto 12px;
}
.phone-dialog {
  background: #fff;
  border-radius: 1rem;
  padding: 16px;
  min-height: 160px;
}
.phone-dialog h6 {
  color: #1A1D29;
}
.phone-dialog p {
  color: #344054;
}
.phone-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
}
.phone-btn-text {
  color: #8392AB;
  font-size: 0.8rem;
  font-weight: 600;
}
.phone-btn-filled {
  background-color: #C8102E;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 999px;
}
</style>
